import { Button } from '@mui/material';
import { FiExternalLink } from 'react-icons/fi';

interface JumpToWorkflowProps {
  projectId: string;
  workflowId: string;
  revision?: string | number;
}

export const JumpToWorkflow = ({ projectId, workflowId, revision }: JumpToWorkflowProps) => {
  let href = `/projects/${projectId}/workflows/${workflowId}/canvas`;
  if (revision) {
    href += `/revision/${revision}`;
  }

  return (
    <Button
      variant="outlined"
      color="info"
      size="small"
      href={href}
      target="_blank"
      endIcon={<FiExternalLink size={14} />}
      sx={{ textTransform: 'none', borderRadius: '10px' }}
    >
      Jump to workflow
    </Button>
  );
};
